var _defs, _path, _polygon, _polygon2, _polygon3, _polygon4, _g, _path2, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _path3, _polygon11, _polygon12, _polygon13, _ellipse, _polygon14, _polygon15, _polygon16, _path4, _polygon17, _polygon18, _polygon19, _ellipse2, _ellipse3, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "project_menagement",
    xmlns: "http://www.w3.org/2000/svg",
    width: 594.2403,
    height: 379.9185,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 594.2403 379.9185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient-4);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11{opacity:.5;}.cls-12{fill:#001863;}.cls-2{fill:url(#radial-gradient-3);}.cls-3{fill:url(#radial-gradient-9);}.cls-4{fill:url(#radial-gradient-10);}.cls-13{fill:#1341c4;}.cls-5{fill:url(#radial-gradient);}.cls-14,.cls-8{fill:#2487fb;}.cls-6{fill:url(#radial-gradient-7);}.cls-7{fill:url(#radial-gradient-2);}.cls-15{fill:#072b88;}.cls-9{fill:url(#radial-gradient-8);}.cls-10{fill:url(#radial-gradient-5);}.cls-11{fill:url(#radial-gradient-6);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -3382.7838,
    cy: -446.2496,
    fx: -3382.7838,
    fy: -446.2496,
    r: 12.9919,
    gradientTransform: "translate(-2285.0641 1215.5358) rotate(153.0966) scale(.8957 .8599) skewX(-1.7343)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02689b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4129,
    stopColor: "#02689b",
    stopOpacity: 0.5504
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8114,
    stopColor: "#02689b",
    stopOpacity: 0.154
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02689b",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -3258.1853,
    cy: -612.2207,
    fx: -3258.1853,
    fy: -612.2207,
    r: 12.9919,
    gradientTransform: "translate(-2285.0641 1175.3521) rotate(154.0116) scale(.8887 .8327)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02689b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02689b",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -1948.2347,
    cy: 2629.9231,
    fx: -1948.2347,
    fy: 2629.9231,
    r: 16.063,
    gradientTransform: "translate(-2649.0568 -676.4879) rotate(-111.7619) scale(.8887 .8327)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 197.3982,
    cy: 746.3391,
    fx: 197.3982,
    fy: 746.3391,
    r: 23.8803,
    gradientTransform: "translate(26.2532 -256.2737) scale(1.1392 .8152)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -2532.3095,
    cy: 1261.0053,
    fx: -2532.3095,
    fy: 1261.0053,
    r: 15.4957,
    gradientTransform: "translate(-1647.308 2237.6016) rotate(116.0663) scale(1.1392 -.8151)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -1757.5956,
    cy: -1193.192,
    fx: -1757.5956,
    fy: -1193.192,
    r: 23.8802,
    gradientTransform: "translate(-903.2235 -1827.5538) rotate(-89.9986) scale(1.1392 -.8151)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -1695.4007,
    cy: -1322.1083,
    fx: -1695.4007,
    fy: -1322.1083,
    r: 23.8802,
    gradientTransform: "translate(-993.8825 -1881.0493) rotate(-89.9986) scale(1.1392 -.8151)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: -2744.3165,
    cy: -292.7,
    fx: -2744.3165,
    fy: -292.7,
    r: 12.9919,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: -3108.0887,
    cy: -122.2901,
    fx: -3108.0887,
    fy: -122.2901,
    r: 12.9919,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -3363.4879,
    cy: -200.8903,
    fx: -3363.4879,
    fy: -200.8903,
    r: 12.9919,
    xlinkHref: "#radial-gradient-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M569.5624,197.3802c-2.6183-5.5901-.0947-12.4795,5.6367-15.388,5.7314-2.9085,12.5003-.7346,15.1186,4.8554,2.6184,5.5901,.0947,12.4795-5.6367,15.388-5.7314,2.9084-12.5002,.7345-15.1186-4.8554Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "470.7583 16.9295 472.1743 18.9036 479.4523 16.8324 479.9559 10.3327 477.1246 6.3853 470.0339 13.4233 470.7583 16.9295"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "470.0339 13.4233 475.3951 13.6841 479.9559 10.3327 477.1246 6.3853 470.0339 13.4233"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "12.3042 332.8022 14.6959 333.2286 18.4651 326.6672 14.2912 321.6593 9.5089 320.8066 9.3391 330.7957 12.3042 332.8022"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "9.3391 330.7957 13.3619 327.2422 14.2912 321.6593 9.5089 320.8066 9.3391 330.7957"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "582.7793 197.8985 580.3876 198.3249 576.6184 191.7635 580.7923 186.7556 585.5746 185.9029 585.7444 195.892 582.7793 197.8985"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "585.7444 195.892 581.7216 192.3385 580.7923 186.7556 585.5746 185.9029 585.7444 195.892"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M530.5959,369.9215c-2.6183-5.3706-.0947-11.9895,5.6367-14.7838,5.7314-2.7943,12.5003-.7058,15.1186,4.6648,2.6184,5.3706,.0947,11.9895-5.6367,14.7838-5.7314,2.7942-12.5002,.7057-15.1186-4.6648Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "548.2034 363.9406 547.1387 361.7568 539.6164 362.5776 538.0295 368.9007 540.1583 373.2671 548.3293 367.5186 548.2034 363.9406"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "548.3293 367.5186 543.0879 366.362 538.0295 368.9007 540.1583 373.2671 548.3293 367.5186"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "235.9262 57.7578 236.745 60.045 244.312 60.0538 246.5824 53.9427 244.9451 49.3692 236.1932 54.1875 235.9262 57.7578"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "236.1932 54.1875 241.2763 55.9117 246.5824 53.9427 244.9451 49.3692 236.1932 54.1875"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "27.6566 126.8669 29.9129 125.9662 29.6494 118.4038 23.4606 116.3548 18.949 118.1557 24.0791 126.7285 27.6566 126.8669"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "24.0791 126.7285 25.6192 121.5866 23.4606 116.3548 18.949 118.1557 24.0791 126.7285"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.5769,106.4696c6.8613-2.7388,14.7928,.9769,17.7156,8.2992,2.9228,7.3222-.27,15.4783-7.1313,18.2171-6.8612,2.7388-14.7928-.9769-17.7156-8.2992-2.9227-7.3222,.27-15.4783,7.1313-18.2171Z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "228.0173 358.6202 231.6293 352.5675 243.7285 345.5865 253.9496 345.2376 265.0474 356.5367 264.3951 370.2063 256.1984 376.3525 236.2425 379.3751 230.1844 363.5673 228.0173 358.6202"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "243.7285 345.5865 233.1075 353.5417 240.5718 364.7084 257.4872 367.0417 265.0474 356.5367 264.3951 370.2063 256.1984 376.3525 236.2425 379.3751 228.0173 358.6202 231.6293 352.5675 243.7285 345.5865"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "236.2425 379.3751 240.5718 364.7084 233.1075 353.5417 228.0173 358.6202 236.2425 379.3751"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 251.0985,
    cy: 352.1216,
    rx: 27.2046,
    ry: 19.466,
    transform: "translate(-46.9451 38.7367) rotate(-8.07)"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "554.9339 89.8125 550.685 88.1197 541.6977 89.2977 536.2948 93.151 535.0363 103.3505 540.7661 110.1349 547.4136 110.0667 558.8863 103.7495 555.7696 93.216 554.9339 89.8125"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "541.6977 89.2977 550.3079 89.2049 550.869 97.9024 543.0759 105.7789 535.0363 103.3505 540.7661 110.1349 547.4136 110.0667 558.8863 103.7495 554.9339 89.8125 550.685 88.1197 541.6977 89.2977"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "558.8863 103.7495 550.869 97.9024 550.3079 89.2049 554.9339 89.8125 558.8863 103.7495"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M535.9115,113.7041c6.2665,3.0653,14.8193-1.5494,19.1031-10.3072,4.2838-8.7578,2.6764-18.3423-3.5901-21.4075-6.2666-3.0652-14.8194,1.5495-19.1031,10.3072s-2.6764,18.3423,3.5902,21.4074Z"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "84.2985 192.7989 84.9633 185.7818 79.3313 172.9987 71.2936 166.6752 55.6631 169.2281 51.5844 183.2426 63.7972 203.087 65.3952 204.6767 79.6262 195.508 84.2985 192.7989"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "79.3313 172.9987 83.1951 185.6937 70.5736 190.2878 68.401 178.3572 55.6631 169.2281 51.5844 183.2426 65.3952 204.6767 65.3952 204.6767 84.2985 192.7989 84.9633 185.7818 79.3313 172.9987"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "65.3952 204.6767 70.5736 190.2878 83.1951 185.6937 84.2985 192.7989 65.3952 204.6767"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 69.349,
    cy: 174.7617,
    rx: 19.466,
    ry: 27.2045,
    transform: "translate(-104.1501 102.3117) rotate(-45.6913)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 83.7767,
    cy: 50.4127,
    rx: 19.466,
    ry: 27.2045,
    transform: "translate(-2.8862 5.1412) rotate(-3.4555)"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "68.401 178.3572 57.637 192.636 51.5844 183.2426 55.6631 169.2281 68.401 178.3572"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "79.4938 64.3754 85.5771 60.8151 92.6609 48.7758 93.0969 38.5581 81.8928 27.3644 68.1361 32.2423 59.1663 53.748 58.8098 55.9736 74.5653 62.1662 79.4938 64.3754"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "92.6609 48.7758 84.6155 59.3286 73.5128 51.7695 81.9261 43.0358 81.8928 27.3644 68.1361 32.2423 58.8098 55.9736 58.8098 55.9736 79.4938 64.3754 85.5771 60.8151 92.6609 48.7758"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "58.8098 55.9736 73.5128 51.7695 84.6155 59.3286 79.4938 64.3754 58.8098 55.9736"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "81.9261 43.0358 63.7234 43.4705 68.1361 32.2423 81.8928 27.3644 81.9261 43.0358"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3.5244,330.8607c-2.6183-5.3706-.0947-11.9895,5.6367-14.7838,5.7314-2.7943,12.5003-.7058,15.1186,4.6648,2.6184,5.3706,.0947,11.9895-5.6367,14.7838-5.7314,2.7942-12.5002,.7057-15.1186-4.6648Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.9231,61.656c-2.6183-5.3706-.0947-11.9895,5.6367-14.7838,5.7314-2.7943,12.5003-.7058,15.1186,4.6648,2.6184,5.3706,.0947,11.9895-5.6367,14.7838-5.7314,2.7942-12.5002,.7057-15.1186-4.6648Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M464.6172,21.0358c-2.6183-5.3706-.0947-11.9895,5.6367-14.7838,5.7314-2.7943,12.5003-.7058,15.1186,4.6648,2.6184,5.3706,.0947,11.9895-5.6367,14.7838-5.7314,2.7942-12.5002,.7057-15.1186-4.6648Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStone);
export default __webpack_public_path__ + "static/media/stone.d7a1f0453dc1a3e7f23e46f4b17d8a7d.svg";
export { ForwardRef as ReactComponent };